import { GET_VISITS_REPORT_START, GET_VISITS_REPORT_SUCCESS, GET_VISITS_REPORT_ERROR } from '../../../constants/ActionTypes';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    visitsReport: []
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_VISITS_REPORT_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case GET_VISITS_REPORT_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, visitsReport: action.visitsReport.length > 0 ? [...action.visitsReport] : [] };

        }
        case GET_VISITS_REPORT_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        default:
            return state;
    }
}